import { Snackbar as NovaSnackbar } from '@fme-nova/components'
import { default as MuiSnackbar, SnackbarProps } from '@mui/material/Snackbar'
import React, { useState } from 'react'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'
import { AlertTitle, BaseAlert } from '../BaseAlert'
import { Markdown } from '../Markdown'

const MuiStyledToast: MsdkStyledComponent<SnackbarProps> = styled(MuiSnackbar)``

export const StyledToast = createComponentWrapperWithRef<SnackbarProps>(
  {
    mui: MuiStyledToast,
    nova: NovaSnackbar,
  },
  'StyledToast',
)

const StyledAlert = styled(BaseAlert)`
  min-width: 400px;
  max-width: 50vw;
`

const Alert = createComponentWrapperWithRef(
  {
    mui: StyledAlert,
    nova: StyledAlert,
    novaProps: {
      variant: 'actionable',
    },
  },
  'Alert',
)

const StyledMessage = styled('div')`
  p {
    margin: 0;
  }
`
type CustomNotificationProps = {
  open: boolean
  title?: string
  message: string | React.ReactNode
  severity: 'success' | 'info' | 'warning' | 'error'
  time?: number
  waitUserAck?: boolean
  closeOnClick?: boolean
  onClose?: () => void
  customMessageRenderer?: React.ReactNode
}

/** @component */
export const ToastNotification = (props: CustomNotificationProps) => {
  const { onClose, waitUserAck, closeOnClick, customMessageRenderer, ...rest } = props
  const [open, setOpen] = useState<boolean>(props.open)

  const onCloseInternal = () => {
    setOpen(false)
    if (onClose) {
      onClose()
    }
  }

  const timeToUse = waitUserAck ? undefined : props.time ?? 6000

  return (
    <StyledToast
      data-test-id="toast-notif"
      autoHideDuration={timeToUse}
      onClose={onCloseInternal}
      {...rest}
      open={open}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Alert onClose={onClose} onClick={closeOnClick ? onCloseInternal : undefined} severity={props.severity}>
        {props.title && <AlertTitle>{props.title}</AlertTitle>}
        {customMessageRenderer}
        {typeof props.message === 'string' && !customMessageRenderer && (
          <StyledMessage>
            <Markdown>{props.message}</Markdown>
          </StyledMessage>
        )}
        {typeof props.message !== 'string' && !customMessageRenderer && <>{props.message}</>}
      </Alert>
    </StyledToast>
  )
}
